import clsx from 'clsx';
import React from 'react';

// Global rules the login pages depend on (full-height document, universal
// margin reset). A static style element is part of the server-rendered
// markup, so the page paints in its final state instead of waiting for
// emotion to inject them on the client.
const LOGIN_PAGE_GLOBAL_CSS = [
  '*{margin:0;padding:0}',
  'html{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;height:100%;width:100%}',
  'body{height:100%;width:100%}',
].join('');

interface LoginPageLayoutProps {
  children?: React.ReactNode;
  className?: string;
}

export const LoginPageLayout: React.FC<LoginPageLayoutProps> = ({
  children,
  className,
}) => {
  return (
    <div
      className={clsx(
        'flex h-full min-h-full justify-center font-["Inter","Helvetica","Arial",sans-serif] [@media(min-height:700px)]:items-center',
        className,
      )}
    >
      <style dangerouslySetInnerHTML={{ __html: LOGIN_PAGE_GLOBAL_CSS }} />
      <div
        className="mx-auto box-border block w-full px-0 sm:px-6 xl:max-w-[1280px] max-sm:h-full"
        data-test-id="login-page-layout"
      >
        {children}
      </div>
    </div>
  );
};
